export * as intakeForms from '@wix/auto_sdk_intake-forms_intake-forms/schemas';
export * as intakeFormSubmissions from '@wix/auto_sdk_intake-forms_intake-form-submissions/schemas';
